module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Billing")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(
    _vm.mainExecutionDetails.length > 0 &&
    (_vm.mainExecutionDetails[0].finalBillingCompleted == '1' || _vm.mainExecutionDetails[0].finalBillingCompleted == '4')
  ) ? _c('b-button', {
    attrs: {
      "disabled": _vm.ffInvoiceModal.sentForRevisedApproval == '1' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.openPop
    }
  }, [_vm._v("Revised Billing Request")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.ffInvoiceModal.revisedActionTakenFromMail == '2') ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Request Rejected")]) : _vm._e(), _vm._v(" "), (_vm.ffInvoiceModal.sentForRevisedApproval == '1') ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Sent For Approval")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.$route.params.billingId) ? _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.$route.params.billingId ? _vm.$route.params.billingId : '',
      "jobSeriesBanner": _vm.ffInvoiceModal.jobNo ? _vm.ffInvoiceModal.jobNo : '',
      "bannerClientName": _vm.ffInvoiceModal.clientName ? _vm.ffInvoiceModal.clientName : '',
      "iconId": "fa fa-ship"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "pull-right",
    attrs: {
      "md": "12"
    }
  }, [_c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard'), _vm._v(" "), (_vm.brf_id) ? _c('BRFCard', {
    attrs: {
      "BRFDetails": null,
      "prbr_id": Number(_vm.brf_id)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newJobType.length > 0) ? _c('RejectInvTallyBill', {
    attrs: {
      "RTBI_title": ("Remove Or Reject Wrong Invoices Module JOB NO : " + (_vm.mainExecutionDetails[0].mainSalesSeries)),
      "RTBI_JOBID": _vm.mainExecutionDetails[0].allModuleId,
      "RTBI_JOBNO": _vm.mainExecutionDetails[0].mainSalesSeries,
      "RTBI_JOBDATE": _vm.mainExecutionDetails[0].loginTime,
      "RTBI_JOBTYPE": _vm.mainExecutionDetails[0].jobType,
      "RTBI_Selected_JOBTYPE": _vm.newJobType,
      "RTBI_IS_Consolidation": _vm.mainExecutionDetails[0].isConsolidation,
      "RTBI_IS_Misc": _vm.mainExecutionDetails[0].isMiscJob,
      "RTBI_Client": _vm.mainExecutionDetails[0].clientName,
      "RTBI_clientId": _vm.mainExecutionDetails[0].clientId,
      "RTBI_Sline": _vm.mainExecutionDetails[0].shippingId,
      "RTBI_ffInvoiceModal": _vm.ffInvoiceModal,
      "RTBI_showSegmentArray": _vm.showSegmentArray,
      "RTBI_InvBtnRejection_btnFlag": _vm.InvBtnRejection_btnFlag,
      "RTBI_InvTallyId": _vm.$route.query.InvTallyId
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.billingTableData.length > 0) ? _c('div', {
    staticClass: "box-header"
  }, [(
    _vm.mainExecutionDetails.length > 0 &&
    _vm.mainExecutionDetails[0].finalBillingCompleted == '0'
  ) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.showMoreItem
    }
  }, [_vm._v(_vm._s(_vm.showMoreNewItem == false ?
    "Show Existing Billing Details" :
    "New Billing "))]) : _vm._e(), _vm._v(" "), (
    _vm.mainExecutionDetails.length > 0 &&
    (_vm.mainExecutionDetails[0].finalBillingCompleted != '1' || _vm.mainExecutionDetails[0].finalBillingCompleted != '4') &&
    _vm.showMoreNewItem == true
  ) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.closeBill(_vm.mainExecutionDetails[0].allModuleId)
      }
    }
  }, [_vm._v("Close Billing")]) : _vm._e(), _vm._v(" "), (_vm.mainExecutionDetails[0].assignmentCloseReason) ? _c('span', {
    staticStyle: {
      "color": "green"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mainExecutionDetails[0].assignmentCloseReason)
    }
  }, [_vm._v(_vm._s(_vm.mainExecutionDetails[0].assignmentCloseReason))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.billingTableData.length > 0) ? _c('div', {
    staticClass: "box"
  }, [(_vm.showMoreNewItem == true) ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ffContainer"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Tally Invoice No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Job Type")]), _vm._v(" "), _c('th', [_vm._v("Tally Status")]), _vm._v(" "), _c('th', [_vm._v("Added In Tally")]), _vm._v(" "), _c('th', [_vm._v("Date & Details")]), _vm._v(" "), _c('th', [_vm._v("PDF")])]), _vm._v(" "), _vm._l((_vm.billingTableData), function(item1, index) {
    return _c('tr', {
      key: index,
      style: (item1.TallyResponse == '' ?
        'color:red' :
        item1.LINEERROR == '' && item1.CREATED != '0' ?
        'color:green ' :
        'color:red')
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      style: (item1.TallyResponse == '' ?
        'color:red' :
        item1.LINEERROR == '' && item1.CREATED != '0' ?
        'color:green ' :
        'color:red'),
      on: {
        "click": function($event) {
          _vm.getBillData(item1)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item1.BillingSeries) + "\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item1.clientName) + "\n                        "), _c('br'), _vm._v(" "), (item1.invoiceForClient == '2') ? _c('b-badge', [_vm._v("Overseas Agent")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.jobType))]), _vm._v(" "), _c('td', [_vm._v("\n                        " + _vm._s(item1.TallyResponse == "" ?
      "Failed To connect to Tally" :
      item1.LINEERROR == "" && item1.CREATED != "0" ?
      "DATA ADDED SUCCESSFULLY IN TALLY " :
      item1.LINEERROR) + "\n                      ")]), _vm._v(" "), _c('td', [_c('md-icon', {
      staticClass: "md-size md-accent",
      style: (item1.TallyResponse == '' ?
        'color:red' :
        item1.LINEERROR == '' && item1.CREATED != '0' ?
        'color:green ' :
        'color:red')
    }, [_vm._v(_vm._s(item1.TallyResponse == "" ?
      "clear" :
      item1.LINEERROR == "" && item1.CREATED != "0" ?
      "done_outline" :
      "clear"))])], 1), _vm._v(" "), _c('td', [_vm._v("\n                        On " + _vm._s(item1.loginTime) + "\n                        "), _c('br'), _vm._v("\n                        By " + _vm._s(item1.employeeName) + "\n                        "), _c('br'), _vm._v("\n                        At " + _vm._s(item1.billingLocationName) + "\n                      ")]), _vm._v(" "), _c('td', [(item1.dataPdf) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/TALLY_PDF/" + item1.dataPdf,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View PDF")]) : _vm._e()])])
  })], 2)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showMoreNewItem == false || _vm.billingTableData.length == 0) ? _c('div', [(_vm.ffInvoiceModal.billingId == '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "90",
      "md-flex-small": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex-small": "100"
    }
  }, _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": segmentNameArray.flex,
        "md-flex-small": "100"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'jobType' + (index + 1),
        "id": 'jobType' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.jobTypeSelect(segmentNameArray.value, index);
          _vm.getOceanFreight();
        }
      },
      model: {
        value: (_vm.ffInvoiceModal.jobType[index]),
        callback: function($$v) {
          _vm.$set(_vm.ffInvoiceModal.jobType, index, $$v)
        },
        expression: "ffInvoiceModal.jobType[index]"
      }
    }, [_c('b', [_vm._v(_vm._s(segmentNameArray.show))])])], 1)
  }))], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.PreviousbillingTableData.length > 0 && _vm.newJobType.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body row"
  }, _vm._l((_vm.PreviousbillingTableData), function(pre_item, pre_index) {
    return _c('div', {
      key: pre_index,
      staticClass: "col-md-2"
    }, [(pre_item.BillingSeries) ? _c('b-button', {
      staticClass: "mt-2",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": "info"
      },
      on: {
        "click": function($event) {
          _vm.getPreviousTallyData(pre_item)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(pre_item.BillingSeries))])]) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Job No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.jobNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "jobNo", $$v)
      },
      expression: "ffInvoiceModal.jobNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Employee Billing Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false,
      "list": _vm.billingLocationData,
      "option-value": "billingLocationId",
      "option-text": "billingLocation",
      "placeholder": "Select Billing Location"
    },
    on: {
      "input": _vm.getBillingBranch
    },
    model: {
      value: (_vm.ffInvoiceModal.billingLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "billingLocationId", $$v)
      },
      expression: "ffInvoiceModal.billingLocationId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('div', {
    staticClass: "mr-4"
  }, [_c('label', {
    staticStyle: {
      "width": "44px"
    }
  }, [_vm._v(" Other Clients")]), _vm._v(" "), _c('b-form-checkbox', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "name": "check-button",
      "switch": ""
    },
    model: {
      value: (_vm.otherClientChecked),
      callback: function($$v) {
        _vm.otherClientChecked = $$v
      },
      expression: "otherClientChecked"
    }
  })], 1), _vm._v(" "), (
    _vm.mainExecutionDetails.length > 0 &&
    _vm.mainExecutionDetails[0].clientType == '3'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Invoice For")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientTypeList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select "
    },
    on: {
      "input": _vm.changeClient
    },
    model: {
      value: (_vm.ffInvoiceModal.invoiceForClient),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "invoiceForClient", $$v)
      },
      expression: "ffInvoiceModal.invoiceForClient"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.mainExecutionDetails.length > 0 &&
    _vm.mainExecutionDetails[0].clientType == '3'
  ) ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.otherClientChecked == false ? true : false,
      "list": _vm.clientData,
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select "
    },
    on: {
      "input": _vm.changeOtherClient
    },
    model: {
      value: (_vm.ffInvoiceModal.clientId),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "clientId", $$v)
      },
      expression: "ffInvoiceModal.clientId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Contact")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.contact),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "contact", $$v)
      },
      expression: "ffInvoiceModal.contact"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client GSTN")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.clientgst),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "clientgst", $$v)
      },
      expression: "ffInvoiceModal.clientgst"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("State")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.stateName),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "stateName", $$v)
      },
      expression: "ffInvoiceModal.stateName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.adress),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "adress", $$v)
      },
      expression: "ffInvoiceModal.adress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Pickup Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.pickup),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "pickup", $$v)
      },
      expression: "ffInvoiceModal.pickup"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Handover Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.Handover),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "Handover", $$v)
      },
      expression: "ffInvoiceModal.Handover"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Factory Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.factoryLoc),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "factoryLoc", $$v)
      },
      expression: "ffInvoiceModal.factoryLoc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place Of Receipt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POR),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POR", $$v)
      },
      expression: "ffInvoiceModal.POR"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Load Port")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.LP),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "LP", $$v)
      },
      expression: "ffInvoiceModal.LP"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port Of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POD", $$v)
      },
      expression: "ffInvoiceModal.POD"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.FPOD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "FPOD", $$v)
      },
      expression: "ffInvoiceModal.FPOD"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shippingLine", $$v)
      },
      expression: "ffInvoiceModal.shippingLine"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel / Voyage")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.vessel),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "vessel", $$v)
      },
      expression: "ffInvoiceModal.vessel"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-4"
  }, [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Container Details : " + _vm._s(_vm.allContainersDataArray.length) + " Container\n                    ")])], 1), _vm._v(" "), (_vm.splitedOrMergedContainers.length > 0) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_vm._v("Container Moved to other assignment ")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.splitedOrMergedContainers,
      "option-value": "uniqueContainerId",
      "option-text": "containerNo",
      "placeholder": ""
    },
    on: {
      "input": _vm.pushSplitedContainers
    },
    model: {
      value: (_vm.splitOrMergeConNo),
      callback: function($$v) {
        _vm.splitOrMergeConNo = $$v
      },
      expression: "splitOrMergeConNo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-sm mt-4 shadow p-3 mb-5 bg-white rounded"
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "bgcolor": "whiteSmoke"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.allContainersDataArray)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select All Count(" + _vm._s(this.singleSelectContainer.length) + ")")])]), _vm._v(" "), _c('th', {
    attrs: {
      "bgcolor": "whiteSmoke"
    }
  }, [_vm._v("Container Type & No.")]), _vm._v(" "), _c('th', [_vm._v("Shipping Bills")]), _vm._v(" "), _c('th', [_vm._v("Shipper Invoices")]), _vm._v(" "), _c('th', [_vm._v("Invoice Added JobNo")])]), _vm._v(" "), _vm._l((_vm.allContainersDataArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "text-align": "center",
        "vertical-align": "middle",
        "width": "20px"
      },
      attrs: {
        "bgcolor": "whiteSmoke"
      }
    }, [_c('b-form-checkbox', {
      attrs: {
        "disabled": item.onlyTPT == '1' &&
          (_vm.newJobType.includes('FF') ||
            _vm.newJobType.includes('CC') ||
            _vm.newJobType.length <= 0) ?
          true :
          false,
        "size": "lg",
        "value": item.uniqueContainerId
      },
      on: {
        "change": function($event) {
          _vm.updateSelectAll($event, item)
        }
      },
      model: {
        value: (_vm.singleSelectContainer),
        callback: function($$v) {
          _vm.singleSelectContainer = $$v
        },
        expression: "singleSelectContainer"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left",
        "vertical-align": "middle",
        "width": "200px"
      },
      attrs: {
        "bgcolor": item.onlyTPT == '1' ? 'red' : 'whiteSmoke'
      }
    }, [_c('span', [_vm._v(_vm._s(item.containerType) + " ")]), _vm._v(" "), (item.containerNo) ? _c('b', [_c('br'), _vm._v(_vm._s(item.containerNo))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (item.onlyTPT == '1') ? _c('b-button', {
      staticClass: "pull-right",
      attrs: {
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          _vm.removeContainerType(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]) : _vm._e(), _vm._v(" "), (item.invoiceNoCreated) ? _c('span', {
      staticStyle: {
        "color": "blue"
      }
    }, [_c('br'), _c('b', [_vm._v("Invoice Created: " + _vm._s(item.invoiceNoCreated))])]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("\n                          SB No. : " + _vm._s(item.shippingBillNo)), _c('br'), _vm._v("\n                          SB Date :\n                          " + _vm._s(item.shippingBillDate ? item.shippingBillDate : "") + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          Shipper Inv No. : " + _vm._s(item.shipperInvoiceNo)), _c('br'), _vm._v("\n                          Date :\n                          " + _vm._s(item.shipperInvoiceDate ?
      item.shipperInvoiceDate.split(" ")[0] :
      "") + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(item.assignNoInwhichInvCreated) + "\n                          ")])])
  })], 2)]), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.containerDetailsNew),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "containerDetailsNew", $$v)
      },
      expression: "ffInvoiceModal.containerDetailsNew"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "multipleContainerType",
      "name": "multipleContainerType"
    },
    model: {
      value: (_vm.ffInvoiceModal.multipleContainerType),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "multipleContainerType", $$v)
      },
      expression: "ffInvoiceModal.multipleContainerType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No/ Date")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.BOE),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "BOE", $$v)
      },
      expression: "ffInvoiceModal.BOE"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice No.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvNo", $$v)
      },
      expression: "ffInvoiceModal.shipperInvNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice Date")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvDate),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvDate", $$v)
      },
      expression: "ffInvoiceModal.shipperInvDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("BL No")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.blNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "blNo", $$v)
      },
      expression: "ffInvoiceModal.blNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weight (KGS)")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.weight),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "weight", $$v)
      },
      expression: "ffInvoiceModal.weight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [(_vm.TPTGRNDATA.length > 0) ? _c('div', {
    staticClass: "box-body gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("TPT Annexure Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("GRN Number")]), _vm._v(" "), _c('th', [_vm._v("Container Number & Type")]), _vm._v(" "), _c('th', [_vm._v("Fuel Slip No.")]), _vm._v(" "), _c('th', [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', [_vm._v("S-Line Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Date")])]), _vm._v(" "), _vm._l((_vm.TPTGRNDATA), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('a', {
      staticClass: "error",
      on: {
        "click": function($event) {
          _vm.getGRNpdf(item.pdfGRN)
        }
      }
    }, [_c('span', {
      staticClass: "error"
    }, [_c('u', [_vm._v(" " + _vm._s(item.GRNSeries))])])])]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(item.containerNo) + "\n                              "), _c('br'), _vm._v("\n                              " + _vm._s(item.multipleContainerType) + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.FuelSlipNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.slineSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customSealNo))]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Loading Date :" + _vm._s(_vm._f("moment")(item.Date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Reporting Date :" + _vm._s(_vm._f("moment")(item.factoryInDate)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Released Date :" + _vm._s(_vm._f("moment")(item.factoryOutDate)))])])])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gutr hide"
  }, [_c('div', {
    staticClass: "box-body gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Expense Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr",
    attrs: {
      "id": "otherExpense"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', [_vm._v("Invoice Type")]), _vm._v(" "), _c('th', [_vm._v("Invoice No.")]), _vm._v(" "), _c('th', [_vm._v("Expense Amount")]), _vm._v(" "), _c('th', [_vm._v("Expense Currency")]), _vm._v(" "), _c('th', [_vm._v("Remark")]), _vm._v(" "), _c('th', [_vm._v("Added on")])]), _vm._v(" "), _vm._l((_vm.otherExpenseData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.vendorName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.exp_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.invoice_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.exp_amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.exp_Currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.exp_remarks))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.loginTime))])])
  }), _vm._v(" "), (_vm.otherExpenseData.length <= 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('b', [_vm._v("NO EXPENSE ADDED")])])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [(_vm.ffInvoiceModal.allModuleId) ? _c('Profit-Loss', {
    attrs: {
      "PMS_fk_all_module_id": _vm.ffInvoiceModal.allModuleId,
      "PMS_jb_series": _vm.ffInvoiceModal.jobNo,
      "PMS_fk_client_id": _vm.ffInvoiceModal.clientName,
      "PLAccordianStatus": false,
      "PLAccordianButton": true
    }
  }) : _vm._e(), _vm._v(" "), _c('Assignment-Timeline', {
    attrs: {
      "TMAccordianStatus": false,
      "TMAccordianButton": true,
      "allModuleId": Number(_vm.ffInvoiceModal.allModuleId)
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('Payment-Summary', {
    attrs: {
      "PMS_fk_all_module_id": _vm.ffInvoiceModal.allModuleId,
      "PMS_jb_series": _vm.ffInvoiceModal.jobNo,
      "PMS_fk_client_id": _vm.ffInvoiceModal.clientName
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId && _vm.is_noe_validation) ? _c('ExpenseTableComponent', {
    ref: "expenseTableComponent",
    attrs: {
      "show-debug": false,
      "initial-expenses": _vm.initialExpenses,
      "enable-validation": true,
      "allModuleId": _vm.ffInvoiceModal.allModuleId,
      "jobNo": _vm.ffInvoiceModal.jobNo,
      "moduleType": 'FF Con',
      "transportType": 'Export',
      "branchId": _vm.$sessionsStorage.get('branch_baseLocation'),
      "invoiceStatus": 1
    },
    on: {
      "expenses-saved": _vm.handleExpensesSaved,
      "expense-validation": _vm.handleExpenseValidation
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('OldExpenseAdditionalTask', {
    attrs: {
      "allModuleId": _vm.ffInvoiceModal.allModuleId,
      "type": 'additional-task'
    }
  }) : _vm._e()], 1), _vm._v(" "), (
    _vm.oceanFreight.indexOf('OCEAN FREIGHT CHARGES-EXPORT') >= 0 ||
    _vm.oceanFreight.indexOf('OCEAN FREIGHT SEZ') >= 0 ||
    _vm.oceanFreight.indexOf('OCEAN FREIGHT CHARGES-IMPORT') >= 0
  ) ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("\n                        Ocean Freight Buying Rates "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "name": "oe_oceanf_rate",
      "id": "oe_oceanf_rate",
      "type": "number"
    },
    model: {
      value: (_vm.common_details.oe_oceanf_rate),
      callback: function($$v) {
        _vm.$set(_vm.common_details, "oe_oceanf_rate", $$v)
      },
      expression: "common_details.oe_oceanf_rate"
    }
  }), _vm._v(" "), (_vm.common_details.oceanFreightRate_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.common_details.oceanFreightRate_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("\n                        Ocean Freight Selling Rates "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "oe_oceanf_sell_rate",
      "id": "oe_oceanf_sell_rate",
      "type": "number"
    },
    on: {
      "input": function($event) {
        _vm.checkBSRate()
      }
    },
    model: {
      value: (_vm.common_details.oe_oceanf_sell_rate),
      callback: function($$v) {
        _vm.$set(_vm.common_details, "oe_oceanf_sell_rate", $$v)
      },
      expression: "common_details.oe_oceanf_sell_rate"
    }
  }), _vm._v(" "), (_vm.common_details.oceanFreightRate_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.common_details.oceanFreightRate_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Currency"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.$store.getters['common/getAllCurrencyList'],
      "option-value": "currency_id",
      "option-text": "currencyCode",
      "placeholder": "Select Currency"
    },
    model: {
      value: (_vm.common_details.oe_fk_currency_id),
      callback: function($$v) {
        _vm.$set(_vm.common_details, "oe_fk_currency_id", $$v)
      },
      expression: "common_details.oe_fk_currency_id"
    }
  }), _vm._v(" "), (_vm.common_details.currency_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.common_details.currency_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Remark :")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "disabled": "",
      "formatter": _vm.capitalizeAll,
      "id": "oe_oceanf_remark",
      "name": "oe_oceanf_remark"
    },
    model: {
      value: (_vm.common_details.oe_oceanf_remark),
      callback: function($$v) {
        _vm.$set(_vm.common_details, "oe_oceanf_remark", $$v)
      },
      expression: "common_details.oe_oceanf_remark"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (
    _vm.showMoreNewItem == false ||
    _vm.ffInvoiceModal.billingId != '' ||
    _vm.billingTableData.length == 0
  ) ? _c('div', {
    staticClass: "mt-2"
  }, [(
    _vm.ffInvoiceModal.billingId != '' &&
    _vm.mainExecutionDetails.length > 0 &&
    _vm.mainExecutionDetails[0].finalBillingCompleted == '0'
  ) ? _c('b-form-checkbox', {
    attrs: {
      "size": "lg",
      "value": "notSelected"
    },
    on: {
      "change": _vm.copyCharges
    },
    model: {
      value: (_vm.selectedTallyInv),
      callback: function($$v) {
        _vm.selectedTallyInv = $$v
      },
      expression: "selectedTallyInv"
    }
  }, [_vm._v("Select to Update Charges Details")]) : _vm._e(), _vm._v(" "), _c('div', [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("CHARGES ")]), _vm._v(" "), (_vm.ffInvoiceModal.billingId == '') ? _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.addQuotationFields
    }
  }, [_c('md-icon', {
    attrs: {
      "md-va": ""
    }
  }, [_vm._v("add")])], 1) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive-lg mt-3 table-light table-bordered shadow p-3 mb-5 bg-white rounded",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "45px"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "ml-2",
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "input": _vm.SelectedAll
    },
    model: {
      value: (_vm.slectedAllStatus),
      callback: function($$v) {
        _vm.slectedAllStatus = $$v
      },
      expression: "slectedAllStatus"
    }
  })], 1), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "170px"
    }
  }, [_c('span', [_vm._v("Particulars * ")])]), _vm._v(" "), (_vm.shipmentType == '1' || _vm.shipmentType == 'Sea_Shipment') ? _c('th', [_c('span', [_vm._v("Container Type")])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "82px"
    }
  }, [_c('span', [_vm._v("Quantity *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Currency *")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_c('span', [_vm._v("Quotation Rate *")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_c('span', [_vm._v("Selling Rate *")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('span', [_vm._v("Exch Rate *")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_c('span', [_vm._v("Final Amount *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Unit *")])]), _vm._v(" "), _c('th', [_c('span', [_vm._v("Remarks")])])]), _vm._v(" "), _vm._l((_vm.ffTallyInvoiceData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      attrs: {
        "bgColor": item.color && item.color == '1' ? 'green' : ''
      }
    }, [_c('b-form-checkbox', {
      staticClass: "mt-3 ml-2",
      attrs: {
        "value": "1",
        "unchecked-value": "0"
      },
      on: {
        "change": function($event) {
          _vm.SelectedAllItem(item, index)
        }
      },
      model: {
        value: (item.slectedStatus),
        callback: function($$v) {
          _vm.$set(item, "slectedStatus", $$v)
        },
        expression: "item.slectedStatus"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['common/getAllLedgerList'],
        "option-value": "ledger",
        "option-text": "ledger",
        "placeholder": "Select Particular"
      },
      on: {
        "input": function($event) {
          _vm.getDuplicateLedger(item, index);
          _vm.getOceanFreight();
        }
      },
      model: {
        value: (item.ffType),
        callback: function($$v) {
          _vm.$set(item, "ffType", $$v)
        },
        expression: "item.ffType"
      }
    })], 1), _vm._v(" "), (_vm.shipmentType == '1' || _vm.shipmentType == 'Sea_Shipment') ? _c('td', [(_vm.shipmentType == '1' || _vm.shipmentType == 'Sea_Shipment') ? _c('model-list-select', {
      attrs: {
        "list": _vm.containerMasterData,
        "option-value": "containerType",
        "option-text": "containerType"
      },
      model: {
        value: (item.containerType),
        callback: function($$v) {
          _vm.$set(item, "containerType", $$v)
        },
        expression: "item.containerType"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.quantity),
        callback: function($$v) {
          _vm.$set(item, "quantity", $$v)
        },
        expression: "item.quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.currencyList,
        "option-value": "currencyV",
        "option-text": "currencyT"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": item.ffSellingRate ? true : false,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.ffSellingRate),
        callback: function($$v) {
          _vm.$set(item, "ffSellingRate", $$v)
        },
        expression: "item.ffSellingRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.sellingRateFinal),
        callback: function($$v) {
          _vm.$set(item, "sellingRateFinal", $$v)
        },
        expression: "item.sellingRateFinal"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.exchRate),
        callback: function($$v) {
          _vm.$set(item, "exchRate", $$v)
        },
        expression: "item.exchRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number"
      },
      on: {
        "keyup": _vm.MainParticular
      },
      model: {
        value: (item.invAmount),
        callback: function($$v) {
          _vm.$set(item, "invAmount", $$v)
        },
        expression: "item.invAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.unitList,
        "option-value": "unitId",
        "option-text": "unitName"
      },
      model: {
        value: (item.unit),
        callback: function($$v) {
          _vm.$set(item, "unit", $$v)
        },
        expression: "item.unit"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeParticular(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), _vm._v(" "), (_vm.ffTallyInvoiceData.length > 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Total :")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.totFinalPartAmount))])])]), _vm._v(" "), _c('td')]) : _vm._e()], 2)])]), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per gutr mt-5",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [(_vm.ffInvoiceModal.billingId == '') ? _c('b-button', {
    attrs: {
      "block": "",
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.validateBillingParticulars
    }
  }, [_vm._v(_vm._s(_vm.ffInvoiceModal.billingId != "" ? "Update" : "Send Data To Tally"))]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopMaxPer",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopClose",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeBillOk
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopTally",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.submitInvoice
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addValidateClose",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.handleBillingClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51ef5aba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/newTallyConBillingMerge.vue
// module id = 2625
// module chunks = 0